import { Link2, PlusCircle, AlertTriangle, Activity, CheckCircle2 } from 'lucide-react';
import type { MinicrmSummary } from '../../../types/minicrmMigration';

interface Props { summary: MinicrmSummary; }

export function SummaryCards({ summary }: Props) {
  const cards = [
    { icon: Link2, label: 'Auto-link', value: summary.autoLink, tone: 'bg-blue-50 text-blue-700 border-blue-200' },
    { icon: PlusCircle, label: 'Auto-create', value: summary.autoCreate, tone: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
    { icon: AlertTriangle, label: 'Schools pending', value: summary.schoolsPending, tone: summary.schoolsPending > 0 ? 'bg-amber-50 text-amber-800 border-amber-300' : 'bg-gray-50 text-gray-500 border-gray-200' },
    { icon: Activity, label: 'Activities', value: summary.activitiesTotal, tone: 'bg-gray-50 text-gray-600 border-gray-200' },
    { icon: CheckCircle2, label: 'Committed', value: `${summary.committed} / ${summary.total}`, tone: 'bg-green-50 text-green-700 border-green-200' },
  ];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
      {cards.map((c) => (
        <div key={c.label} className={`rounded-md border px-4 py-3 ${c.tone}`}>
          <div className="flex items-center gap-2 text-xs uppercase tracking-wide">
            <c.icon className="h-3.5 w-3.5" />
            {c.label}
          </div>
          <div className="text-2xl font-semibold mt-1">{c.value}</div>
        </div>
      ))}
    </div>
  );
}
